import React, { useEffect } from "react";

import pulseSvg from "@app/assets/map/pulse.svg";
import { useMap } from "@app/component/map/FeaturedMap";

interface Props {
  lookUpLocation?: google.maps.LatLngLiteral;
}

export const GoToLocationPulse: React.FC<Props> = ({ lookUpLocation }) => {
  const { map } = useMap();

  useEffect(() => {
    const pulseMarker = new google.maps.Marker({
      draggable: false,
      icon: { anchor: new google.maps.Point(100, 100), url: pulseSvg },
      map: map,
      position: lookUpLocation,
    });
    const timer = setTimeout(() => pulseMarker.setMap(null), 4000);

    return () => {
      pulseMarker.setMap(null);
      clearTimeout(timer);
    };
  }, [lookUpLocation, map]);

  return null;
};

export default GoToLocationPulse;
